import { render, staticRenderFns } from "./deletedClients.vue?vue&type=template&id=b3f1cd36&scoped=true&"
import script from "./deletedClients.vue?vue&type=script&lang=js&"
export * from "./deletedClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f1cd36",
  null
  
)

export default component.exports